var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.temp_trades),function(data,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(" "+_vm._s(data.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }